/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";

    export interface IDataMaintenanceLocations extends Model.DataMaintenance {
        locationsToTransfer?: Array<any>,
        membershipTypeSettings?: Array<any>,
        membershipTypeSnapshotPoints?: Array<any>,
    }
    enum FilterGroupEnum {
        LocationGroup,
        PriceGroup
    }

    export class SelectLocations extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IDataMaintenanceLocations> {
        public locations: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
        public checkedLocations: any = {};
        public locationsFilter: Model.LocationGroup;
        public priceGroupFilter: any;
        public filterGroup: FilterGroupEnum = FilterGroupEnum.LocationGroup;
        public today: Date;
        public locationsToTransfer: any = [];

        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService,
                    protected scheduleLocationService: Meevo.Plugins.MarketPricing.ScheduleLocationService) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings
            );

            this.today = new Date();
            this.today.setHours(0,0,0,0);

            // Initialize
            this.locations = new Meevo.Components.BaseClasses.PagedResults(this.dataService, "location");

        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void { }

        /**
        * When tab is activated
        * */
        public sectionModelRetrieved(): void {

            if (this.model == '' && !this.model.locationsToTransfer) {
                this.model = {};
                this.model.locationsToTransfer = [];
            } else {
                this.sortLocationsToTransferByName();
            }
        }

        public activate(): void {
            super.activate();
            this.selectLocations();
        }

        public filterTypeaheadResults(response, request): void {
            if (this.filterGroup === FilterGroupEnum.LocationGroup) {
                let allValueItem = _.find(response, function (item) {
                    return item['id'] === null;
                });

                if (!allValueItem && request.pageNumber === 0) {
                    let itemAll = {
                        id: null,
                        displayName: 'All'
                    };
                    response.unshift(itemAll);
                }
            } else if (this.filterGroup === FilterGroupEnum.PriceGroup) {
                let index = response.findIndex(item => item['id'] === this.parentItemId);

                if (index >= 0) {
                    response.splice(index, 1);
                }
            }
        }

        public addSelectedLocations(): void {
            let arrLocations = [];

            _.each(this.checkedLocations, (loc: any) => {
                let isSelectedBefore = _.findWhere(this.model.locationsToTransfer, { locationId: loc.id });

                if (!isSelectedBefore) {
                    arrLocations.push({
                        locationId: loc.id,
                        locationName: loc.storeName,
                        locationNumber: loc.storeNumber,
                        currentMarketName: loc.currentMarketName,
                    });
                }
            });

            Array.prototype.push.apply(this.model.locationsToTransfer, arrLocations);

            this.sortLocationsToTransferByName();
        }

        public removeLocation(item): void {
            this.model.locationsToTransfer = _.without(this.model.locationsToTransfer, item);
        }

        public selectLocations(): void {
            let request = {
                pageNumber: 0,
                itemsPerPage: 24,
                criteria: {
                    includeActive: true,
                    excludePriceGroupId: this.parentItemId,
                    priceGroupId: this.filterGroup === FilterGroupEnum.PriceGroup && this.priceGroupFilter ? this.priceGroupFilter.id : '',
                    locationGroupId: this.filterGroup === FilterGroupEnum.LocationGroup && this.locationsFilter ? this.locationsFilter.id : ''
                },
                sortDirection: Model.SortDirection.Ascending,
            };

            this.checkedLocations = {};
            this.locations.clearSearch();
            this.locations.initSearch(request);
        }

        public selectLocation(item): void {
            if (this.checkedLocations[item.id]) {
                delete this.checkedLocations[item.id];
            } else {
                this.checkedLocations[item.id] = item;
            }
        }

        public preSave(): void {
            this.model['locationIds'] = _.map(this.model.locationsToTransfer, (loc) => {
                return loc.locationId;
            });

            let counter = 0;

            for (let i = 0; i < this.model['locationIds'].length; i++) {
                let el = _.findWhere(this.model.locationsToTransfer, { locationId: this.model['locationIds'][i] }),
                    elIndex = this.model.locationsToTransfer.findIndex(elem => elem.locationId === this.model['locationIds'][i]);


                this.scheduleLocationService.getGrandfatherInfo(el, this.baseEndpoint, this.parentItemId, this.model['priceGroupQueueId']).then((item) => {
                    counter++;

                    this.model.locationsToTransfer[elIndex].membershipTypeSettings = item.membershipTypeSettings;

                    if (counter === this.model.locationsToTransfer.length) {
                        let model = this.scheduleLocationService.prepareGrandfatherModel(this.model);

                        if (this.model['priceGroupQueueId']) {
                            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/marketPricing/${this.model['priceGroupQueueId']}/Grandfather`, 'PUT', model);
                        } else {
                            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/marketPricing/${this.parentItemId}/LocationTransfer`, 'GET', null).then((locationTransfer) =>{
                                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/marketPricing/${locationTransfer.data.priceGroupQueueId}/Grandfather`, 'PUT', model);
                            });
                        }
                        
                    }
                });
            }
        }

        public cleanFilter(): void {
            this.priceGroupFilter = null;
            this.locationsFilter = null;
        }

        get filterGroupEnum(): any {
            return FilterGroupEnum;
        }

        public postCancel() {
            this.cleanFilter();
            this.locations.clearSearch();
            this.checkedLocations = {};
        }

        public sortLocationsToTransferByName(): any {
            this.model.locationsToTransfer.sort((a, b) => {
                if (a.locationName < b.locationName) return -1;
                if (a.locationName > b.locationName) return 1;
                return 0;
            });
        }

        public checkIsLocationInUngrandfathering(id: Guid, inTransfering: boolean): void {
            if (inTransfering) {
                let isLocationInTransfer = this.model.locationsToTransfer.some(loc => loc.locationId === id);

                if (!isLocationInTransfer) {
                    this.params.modalService.alert('WARNING_MSG_MARKET_PRICING_SCHEDULED_UNGRANDFATHER');
                }
            }
        }
    }
}